module.exports = __webpack_public_path__ + "static/media/MZ.7298e775.svg";